export default __webpack_public_path__ + "static/media/no-prospect-sequence.f184797f.svg";